import { useMemo } from "react";
import { useSelector } from "react-redux";

export default (auditId: int) => {
    // TODO: can this be optimised?
    const { auditLocations } = useSelector((state) => state);
    const useCombinedLocations = useMemo(() => {
        if (auditId && auditLocations.data.length) {
            return [
                auditLocations.data.filter((item) => item.audit.id === auditId),
                auditLocations.data.filter((item) => item.audit.id !== auditId),
            ];
        }
        return [[], []];
    }, [auditLocations]);

    return useCombinedLocations;
};
